import React from "react";
import { Modal } from "components";
import { EditSectionTemplate } from "../EditSectionTemplate";
import LanguageDropdown from "components/dropdowns/reactselect/LanguageDropdown";
import { AxiosPromise } from "axios";

interface Props {
  existingTranslations: server.dto.Languages[];
  onClose: () => void;
  saveApi: (language: server.dto.Languages) => AxiosPromise<server.dto.ApiResponse>;
  onTranslationAdded: (language: server.dto.Languages) => void;
}

export const AddTranslationModal = (props: Props) => {
  const [selectedLanguage, setSelectedLanguage] = React.useState<server.dto.Language>(
    serverReference.languages.find(l => !props.existingTranslations.includes(l.value))
  );

  const submit = async () => {
    return props.saveApi(selectedLanguage.value);
  }

  const onSuccess = () => {
    props.onTranslationAdded(selectedLanguage.value);
  }

  return <Modal
    isOpen
    title={RESX.MessageTemplate.AddTranslation}
    handleClose={props.onClose}
    width="tiny"
  >
    <EditSectionTemplate
      submit={submit}
      noPanels
      onSuccess={onSuccess}
      sections={[{
        key: "addTranslation",
        type: "regular",
        title: RESX.MessageTemplate.AddTranslation,
        fields: [{
          key: "language",
          label: RESX.Language.resxLanguage,
          renderEditNew: () => <LanguageDropdown
            value={selectedLanguage}
            onChange={(lang) => setSelectedLanguage(lang)}
            excludeKeys={props.existingTranslations}
          />
        }]
      }]}
    />
  </Modal>
}
